import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["content"];

  connect() {
    this.preconfigureOffsets();

    if (this.hasContentTarget) {
      this.scrollToTask();
    } else {
      this._scrollToTop();
    }

    this._boundScrollToTask = this.scrollToTask.bind(this);
    document.addEventListener("promote:task-scroll", this._boundScrollToTask.bind(this));
  }

  disconnect() {
    document.removeEventListener("promote:task-scroll", this._boundScrollToTask.bind(this));
  }

  preconfigureOffsets() {
    const stickyAccordions = document.querySelectorAll("[data-controller='components--sticky-sections']")
    const stickyAccordionsArray = Array.from(stickyAccordions);

    this.stickyHeaderHeight = (window.innerWidth < 640 ) ? 32 : 40;
    this.topIndex = stickyAccordionsArray.findIndex((element) => element.dataset["sectionId"] == 'task') + 1;

    this.topNavbarOffset = document.getElementById("js-header").offsetHeight;

    this.programBannersOffset = document.getElementById("js-program-banners").offsetHeight;
  }

  scrollToTask() {
    if (this.hasContentTarget) {
      const stickyTopOffset = this.topNavbarOffset + this.programBannersOffset + (this.topIndex * this.stickyHeaderHeight);
      const y = this.contentTarget.getBoundingClientRect().top + window.pageYOffset - stickyTopOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }

  _scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }
}
